import React, { useEffect, useState, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const [adminName, setAdminName] = useState(null); // 상태로 관리
  const [isChecked, setIsChecked] = useState(false); // 로그인 여부 체크 완료 여부
  const hasAlerted = useRef(false); // 알림 중복 방지

  useEffect(() => {
    const storedAdminName = localStorage.getItem("adminName");
    console.log("Stored adminName:", storedAdminName);
    setAdminName(storedAdminName); // 상태 업데이트
    setIsChecked(true); // 체크 완료 상태로 업데이트
  }, []);

  if (!isChecked) {
    // 아직 체크가 완료되지 않은 상태에서는 아무것도 렌더링하지 않음
    return null;
  }

  if (!adminName) {
    if (!hasAlerted.current) {
      alert("로그인이 필요합니다.");
      hasAlerted.current = true; // 알림 표시 후 상태 변경
    }
    return <Navigate to="/admin/admin_login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
